import clsx from 'clsx'

export default function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon,
  className,
  ...props
}) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed'
  
  const variants = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
    secondary: 'bg-gray-200 text-gray-700 hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:ring-offset-2',
    outline: 'border border-primary-600 text-primary-600 bg-transparent hover:bg-primary-50 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2',
    ghost: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
  }

  /*
   * 字号与横向内距走流体令牌（原来 14/16/18px + 12/20/24px 全是恒定值，
   * 小屏上 lg 比周围标签 14px、chip 12px 大一圈）。clamp 上限即原值，桌面不变。
   * 纵向内距不动，并加 min-h 兜底：字号收窄后 md 会掉到 42px，低于 44px 触控下限。
   */
  const sizes = {
    sm: 'px-fluid-3 py-1.5 text-fluid-sm gap-1.5',
    md: 'px-fluid-5 py-2.5 text-fluid-base gap-2 min-h-11',
    lg: 'px-fluid-6 py-3 text-fluid-lg gap-2.5 min-h-11',
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={clsx(baseStyles, variants[variant], sizes[size], className)}
      {...props}
    >
      {loading ? (
        <>
          <span className="loading-spinner" style={{ width: 16, height: 16 }} />
          <span>处理中...</span>
        </>
      ) : (
        <>
          {icon && <span className="flex-shrink-0">{icon}</span>}
          {children}
        </>
      )}
    </button>
  )
}
